import {Component, Input} from '@angular/core';
import {HttpService} from '../../../../services/http.service';
import {SweetUtil} from '../../../commons/sweet/sweet-util-service';
import {FileTypeVerifierPipe} from '../../../../services/filetype-verifier.pipe';
import {I18nPipe} from '../../../../services/i18n.pipe';
import {AuthService} from '../../../../auth/auth.service';
import {Warranty} from '../../../../models/warranties/warranty.model';
import { Router} from '@angular/router';
import {Filter} from '../../../../models/warranties/filter.model';

@Component({
  selector: 'app-upload-warranty-contracts',
  templateUrl: './upload-warranty-contracts.component.html',
  styleUrls: ['./upload-warranty-contracts.component.scss']
})
export class UploadWarrantyContractsComponent {
  @Input() folderFiles: string[] = [];
  @Input() folderName: string;
  @Input()
  warranty: Warranty;
  pdfFiles: string[] = [];
  nonPdfFiles: string[] = [];
  filter: Filter = new Filter();

  constructor(private http: HttpService, private authService: AuthService, private i18nPipe: I18nPipe,
              private sweetUtil: SweetUtil, private fileTypeVerifierPipe: FileTypeVerifierPipe, private router: Router) {
 }

  reload() {
    window.location.reload();
  }
  /**
   * on file drop handler
   */
  onFileDropped($event: File[]) {
    if ($event.length > 1){
      this.sweetUtil.showError('multiple-upload-file-err', '').then();
    }else {
      this.prepareFilesList($event);
    }
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(files: File[]) {
    if (files.length > 1){
      this.sweetUtil.showError('multiple-upload-file-err', '').then();
    }else {
      this.prepareFilesList(files);
    }
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  async prepareFilesList(files: Array<File>) {
    const formData = new FormData();
    for (const item of files) {
      const isFileTypeGenuine = await this.fileTypeVerifierPipe.transform(item);
      if (isFileTypeGenuine && item.type === 'text/csv') {
        formData.append('file', item, item.name);
        this.pdfFiles.push(item.name);
        if (this.nonPdfFiles.length > 0) {
          this.confirmAndPostFiles(formData);
        } else if (formData.getAll('file').length > 0) {
          this.sweetUtil.getConfirmTranslated('upload-warranty-contracts-file-err-title', 'upload-warranty-contracts-replace-confirm-b', 'yes', 'cancel').then((res) => {
            if (res.value){
              this.confirmAndPostFiles(formData);
            }else {
              this.reload();
            }
          });
        }
        this.pdfFiles = [];
        this.nonPdfFiles = [];
      } else {
        this.sweetUtil.showError('upload-warranty-contracts-file-err', 'upload-warranty-contracts-file-err-title').then();
        this.nonPdfFiles.push(item.name);
      }
    }
  }

  /**
   * @param formData
   * @param dialogHeader
   * @param dialogMessage
   * @param action
   */
  confirmAndPostFiles(formData: FormData, dialogHeader = 'success',
                      dialogMessage = 'upload-warranty-contracts-file-success', action = 'save') {
    if (action === 'save') {
      this.postFiles(formData, dialogHeader, dialogMessage);
    }
  }

  /**
   * post files
   * @param formData FormData
   * @param dialogHeader
   * @param dialogMessage
   */
  postFiles(formData: FormData, dialogHeader: string, dialogMessage: string) {
    this.http.postBulkContractCSV(this.folderName, formData).subscribe((res) => {
      this.sweetUtil.showSuccessTranslated(dialogHeader, dialogMessage).then(() => {
        this.router.navigate(['/dashboard']).then();
      });
    }, err => {
      if (err.status === 406) {
        console.error(`Error returned ${JSON.stringify(err)}`);
        this.sweetUtil.showError('warranty-condition-file-406-err').then();
      } else {
        console.error(err);
        this.sweetUtil.showError('upload-warranty-contracts-partial-fail', 'partial-upload-err').then(() => {
          console.error(`Error return ${JSON.stringify(err)}`);
          this.router.navigate(['/dashboard']).then();
        });
      }
    });
  }

  isAdmin(): boolean {
    return this.authService.isAdmin();
  }

  isAuthenticated(): boolean {
    return this.authService.isAuthenticated();
  }

  /**
   * @param x
   * @param y
   */
  intersect = (x, y) => {
    const setY = new Set(y);
    return x.filter(element => setY.has(element));
  }

}
